module.exports = __webpack_public_path__ + "img/cargo-wagon-door-vertical-end.76cc3d70.png";